import { render, staticRenderFns } from "./IndexHomeConfig.vue?vue&type=template&id=0afbea63&scoped=true&lang=pug&"
import script from "./IndexHomeConfig.vue?vue&type=script&lang=ts&"
export * from "./IndexHomeConfig.vue?vue&type=script&lang=ts&"
import style0 from "./IndexHomeConfig.vue?vue&type=style&index=0&id=0afbea63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afbea63",
  null
  
)

export default component.exports